<template>
  <div>
    <div
      v-if="error"
      class="alert alert-danger"
    >
      <p>There was an error, unable to sign in with those credentials.</p>
    </div>
    <b-form @submit.prevent="login">
      <b-form-group
        label="Email address:"
        label-for="email"
        description="We'll never share your email with anyone else."
      >
        <b-form-input
          id="email"
          v-model="form.email"
          type="email"
          required
          placeholder="Enter email"
        />
      </b-form-group>
      <b-form-group
        label="Your Password:"
        label-for="password"
      >
        <b-form-input
          id="password"
          v-model="form.password"
          type="password"
          required
          placeholder="Enter password"
        />
      </b-form-group>
      <b-button
        type="submit"
        variant="primary"
      >
        Login
      </b-button>
      or
      <RouterLink to="/register">
        register
      </RouterLink>
    </b-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: null,
        password: null,
      },
      error: false,
      errors: {},
      success: false,
    };
  },
  methods: {
    login() {
      const app = this;
      this.$auth.login({
        data: app.form,
        success() {
          this.$router.push('/');
        },
        error(resp) {
          app.error = true;
          app.errors = resp.response.data.errors;
        },
        rememberMe: true,
        fetchUser: true,
        redirect: false,
        // redirect: '/dashboard',
      });
    },
  },
};
</script>
